import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3000f406")

_pushScopeId("data-v-3000f406")
const _hoisted_1 = { class: "right-control-components" }
const _hoisted_2 = { class: "cc-menu-button-container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  class: "icon-control",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.5 7.40909C5.5 6.63087 6.13087 6 6.90909 6H11.4545C12.2328 6 12.8636 6.63087 12.8636 7.40909C12.8636 8.18731 12.2328 8.81818 11.4545 8.81818H8.31818V11.9545C8.31818 12.7328 7.68731 13.3636 6.90909 13.3636C6.13087 13.3636 5.5 12.7328 5.5 11.9545V7.40909ZM19.1364 7.40909C19.1364 6.63087 19.7672 6 20.5455 6H25.0909C25.8691 6 26.5 6.63087 26.5 7.40909V11.9545C26.5 12.7328 25.8691 13.3636 25.0909 13.3636C24.3127 13.3636 23.6818 12.7328 23.6818 11.9545V8.81818H20.5455C19.7672 8.81818 19.1364 8.18731 19.1364 7.40909ZM5.5 20.0455C5.5 19.2672 6.13087 18.6364 6.90909 18.6364C7.68731 18.6364 8.31818 19.2672 8.31818 20.0455V23.1818H11.4545C12.2328 23.1818 12.8636 23.8127 12.8636 24.5909C12.8636 25.3691 12.2328 26 11.4545 26H6.90909C6.13087 26 5.5 25.3691 5.5 24.5909V20.0455ZM23.6818 20.0455C23.6818 19.2672 24.3127 18.6364 25.0909 18.6364C25.8691 18.6364 26.5 19.2672 26.5 20.0455V24.5909C26.5 25.3691 25.8691 26 25.0909 26H20.5455C19.7672 26 19.1364 25.3691 19.1364 24.5909C19.1364 23.8127 19.7672 23.1818 20.5455 23.1818H23.6818V20.0455Z",
    fill: "white"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PlaybackSpeedComponent = _resolveComponent("PlaybackSpeedComponent")
  const _component_CCMenuComponent = _resolveComponent("CCMenuComponent")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.IS_IOS)
      ? (_openBlock(), _createBlock(_component_PlaybackSpeedComponent, {
          key: 0,
          videoPlayer: _ctx.videoPlayer
        }, null, 8, ["videoPlayer"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      (_ctx.canUseCaptions.value)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            type: "button",
            role: "button",
            "aria-label": `${_ctx.translateLabels('Captions')}`,
            "aria-haspopup": "true",
            "aria-expanded": _ctx.isCaptionsDropdownShown,
            class: "pw-player-button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCaptions && _ctx.toggleCaptions(...args))),
            ref: "captionBtn",
            innerHTML: _ctx.captionBtnString.value
          }, null, 8, ["aria-label", "aria-expanded", "innerHTML"]))
        : _createCommentVNode("", true),
      (_ctx.isCaptionsDropdownShown)
        ? (_openBlock(), _createBlock(_component_CCMenuComponent, {
            key: 1,
            onMouseleave: _ctx.offCaptionsHover,
            clickCaption: _ctx.clickCaption,
            currentCaptions: _ctx.currentCaptions,
            subtitleArray: _ctx.subtitleArray
          }, null, 8, ["onMouseleave", "clickCaption", "currentCaptions", "subtitleArray"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.canFullScreen)
      ? (_openBlock(), _createBlock("button", {
          key: 1,
          type: "button",
          role: "button",
          "aria-label": `${_ctx.translateLabels('Toggle fullscreen')}`,
          class: "pw-player-button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.togglefullscreen())),
          "aria-controls": "ccmenu"
        }, [
          _hoisted_3
        ], 8, ["aria-label"]))
      : _createCommentVNode("", true)
  ]))
})